import React from 'react';
import './Button.css'; // Import your CSS styles

interface ButtonProps {
  label: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: any; // Accepts the source path of the icon image
}

const Button: React.FC<ButtonProps> = ({ label, variant = 'primary', onClick, icon }) => {
  const iconImg = <img className={`btn-icon fill-${variant}`} src={icon} alt={`${label} icon`}/>
  return (
    <button className={`btn btn-${variant} shadow`} onClick={onClick}>
      {icon && iconImg}
      {label}
    </button>
  );
};


export default Button;
